import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';

import { CustomDialogComponent } from '../modal/customDialog/customDialog.component';

import { ModalService } from '@app/@core/modal/modal.service';
import { SpinnerService } from '../spinner/spinner.service';
import { UserService } from '@app/services/user.service';

import { DefaultActivity } from '@app/interface/activity';

@Component({
  selector: 'app-activity-table',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class ActivityTableComponent {
  @Input() isLoading = false;
  @Input() message: string;
  @Input() dataTable: DefaultActivity[];
  @Input() dataColumn: string;
  first = 0;
  rows = 5;
  values = '';

  constructor(
    private modalService: ModalService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    public userService: UserService
  ) {}

  getIndex(arr: any, activity: any) {
    let index = arr.map((item: any) => item.id).indexOf(activity['id']);
    return index;
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }

  deleteActivity(activity: any): void {
    this.modalService
      .confirm('Are you sure that you want to remove ' + activity['name'])
      .pipe(take(1))
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.spinnerService.show();
          this.removeActivity(activity);
        }
      });
  }

  openEditForm(formData: any): void {
    this.modalService
      .custom(CustomDialogComponent, {
        title: 'Edit Activity',
        modalType: 'add-edit-activity',
        formType: 'Edit',
        formData: formData,
      })
      .pipe(take(1)) // take() manages unsubscription for us
      .subscribe((result: any) => {
        if (result) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Activity is added succesfully.',
          });
        }
      });
  }

  removeActivity(activity: any): void {
    this.userService.deleteDefaultActivity(activity.uuid).then(() => {
      this.spinnerService.hide();
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: activity['name'] + ' is deleted successfully',
      });
    });
  }
}
